import ThreeDotsIcon from "@assets/icons/threeDots"
import styles from "./TableRightSideBarCell.module.css"
import { useState } from "react"
import CrossIcon from "@assets/icons/cross"
import { Link } from "react-router-dom"
import useBooking from "@hooks/useBooking"

const TableRightSideBarCell = ({ appointment, onLocalCancel }) => {
  // console.log("appointment", appointment)
  const [showPatientOptions, setShowPatientOptions] = useState(false)
  const [isCancelling, setIsCancelling] = useState(false)
  const [localCancelled, setLocalCancelled] = useState(false)
  const { handleCancelCalendarBooking, handleCancelGoogleEvent } = useBooking()

  const rightSideBarCellClickHandler = () => {
    setShowPatientOptions((previous) => !previous)
  }

  // Function to check if appointment is in the past
  const isAppointmentCompleted = (startDateTime) => {
    const appointmentDate = new Date(startDateTime)
    const currentDate = new Date()
    return appointmentDate < currentDate
  }

  // Check if appointment can be cancelled (not completed and not already cancelled)
  const canCancelAppointment =
    !isAppointmentCompleted(appointment.startDateTime) &&
    appointment.status !== "cancelled" &&
    !localCancelled

  const handleCancelAppointment = () => {
    if (!canCancelAppointment || isCancelling) return

    // Immediately update UI
    setLocalCancelled(true)
    setIsCancelling(true)
    setShowPatientOptions(false)

    // Notify parent component about the cancellation
    if (onLocalCancel) {
      onLocalCancel(appointment.id)
    }

    const { patientId, eventId, location } = appointment

    if (location === "offline") {
      // For offline appointments, just cancel the calendar booking
      handleCancelCalendarBooking({ patientId, eventId })
        .catch((error) => {
          console.error("Failed to cancel offline appointment:", error)
          // If API fails, revert the UI state
          setLocalCancelled(false)
          // Also notify parent to revert the UI change if API call fails
          if (onLocalCancel) {
            // This is a simplified approach - in production, you'd want a more robust way to revert changes
            // Such as maintaining a map of pending/completed cancellations
          }
        })
        .finally(() => {
          setIsCancelling(false)
        })
    } else {
      // For online appointments, cancel Google event first, then calendar booking
      handleCancelGoogleEvent({ eventId })
        .then(() => {
          return handleCancelCalendarBooking({ eventId, patientId })
        })
        .catch((error) => {
          console.error("Failed to cancel appointment:", error)
          // If API fails, revert the UI state
          setLocalCancelled(false)
          // Also notify parent about the failed cancellation
        })
        .finally(() => {
          setIsCancelling(false)
        })
    }
  }

  // Determine effective status for display in this component
  const effectiveStatus = localCancelled ? "cancelled" : appointment.status

  return (
    <div
      className={styles.rightSideBarCell}
      onClick={rightSideBarCellClickHandler}
    >
      {showPatientOptions ? <CrossIcon /> : <ThreeDotsIcon />}

      {showPatientOptions ? (
        <div className={styles.patientOptions}>
          <Link
            to={`/manage-appointment/appointment-details`}
            state={{ appointment: { ...appointment, status: effectiveStatus } }}
            className={styles.patientOption + " " + styles.viewPatient}
          >
            Appointment Details
          </Link>

          <div
            className={`${styles.patientOption} ${canCancelAppointment ? styles.activateUser : styles.disabledOption}`}
            style={{
              color: canCancelAppointment ? "red" : "#ccc",
              cursor: canCancelAppointment ? "pointer" : "not-allowed",
            }}
            onClick={(e) => {
              e.stopPropagation() // Prevent event bubbling
              if (canCancelAppointment) {
                handleCancelAppointment()
              }
            }}
          >
            {isCancelling ? "Cancelling..." : "Cancel Appointment"}
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default TableRightSideBarCell
